import React from 'react';

import * as S from './PromptAttendanceTable.style';

import AttendanceTableInfo from './PromptAttendanceTableInfo';
import Spinner from '../../../components/spinner/Spinner';
import { observer } from 'mobx-react';

const TH_NAME = [
	'선택',
	'번호',
	'이름',
	'나이',
	'반',
	'출결상태',
	'등교',
	'하교',
	'&emsp;',
	'&emsp;',
];

const PromptAttendanceTable = observer(
	({
		attendance,
		attendanceData,
		date,
		setUser,
		filter,
		loading,
		selectedUserIds = [],
		onToggleUserSelect,
		onToggleAllSelect,
	}) => {
		const filteredData =
			attendanceData?.filter((value) => {
				if (!filter) return true;
				return (
					value.name.includes(filter) || value?.profile?.name.includes(filter)
				);
			}) || [];

		const filteredIds = filteredData.map((item) => String(item.id));
		const isAllSelected =
			filteredIds.length > 0 &&
			filteredIds.every((id) => selectedUserIds.includes(id));

		return (
			<>
				{loading ? (
					<S.SpinnerWrap className={'loading'}>
						<Spinner />
					</S.SpinnerWrap>
				) : (
					<S.Container>
						<thead>
							<tr>
								{TH_NAME.map((name, index) => (
									<th scope='col' key={`${name}_${index}`}>
										{index === 0 ? (
											<input
												type='checkbox'
												checked={isAllSelected}
												onChange={(e) =>
													onToggleAllSelect?.(filteredIds, e.target.checked)
												}
											/>
										) : (
											<span dangerouslySetInnerHTML={{ __html: name }} />
										)}
									</th>
								))}
							</tr>
						</thead>
						<tbody>
							{filteredData.map((value, index) => (
								<AttendanceTableInfo
									key={value.id ?? index}
									value={value}
									attendance={attendance}
									date={date}
									setUser={setUser}
									index={index}
									isSelected={selectedUserIds.includes(String(value.id))}
									onToggleSelect={() => onToggleUserSelect?.(value.id)}
								/>
							))}
						</tbody>
					</S.Container>
				)}
			</>
		);
	},
);

export default PromptAttendanceTable;
